export default "__VITE_ASSET__CjzUD8hk__"